export default "__VITE_ASSET__BP811xRb__"